import { render, staticRenderFns } from "./home-hero-v2.vue?vue&type=template&id=1ed5369b&scoped=true&"
import script from "./home-hero-v2.vue?vue&type=script&lang=js&"
export * from "./home-hero-v2.vue?vue&type=script&lang=js&"
import style0 from "./home-hero-v2.vue?vue&type=style&index=0&id=1ed5369b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed5369b",
  null
  
)

export default component.exports